import "./style.css";
import logo from "../../images/logoFoot.png";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from '@mui/icons-material/YouTube';
import { Button } from "@mui/material";
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import MailIcon from '@mui/icons-material/Mail';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
export default function Footer() {
  const features = [
  {
    icon: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" width="56" height="56">
        <rect x="6" y="14" width="40" height="30" rx="4" fill="#2B3D8F" />
        <path d="M6 20h40" stroke="#fff" strokeWidth="2.5" />
        <circle cx="18" cy="50" r="5" fill="#2B3D8F" />
        <circle cx="36" cy="50" r="5" fill="#2B3D8F" />
        <path d="M46 24l10 4-4 18H6" stroke="#2B3D8F" strokeWidth="3" strokeLinecap="round" />
        <path d="M10 27h26M10 33h18" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
      </svg>
    ),
    title: "+500 produits",
    subtitle: "disponibles en un clic.",
  },
  {
    icon: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" width="56" height="56">
        <circle cx="30" cy="30" r="22" stroke="#2B3D8F" strokeWidth="4" fill="white" />
        <circle cx="30" cy="30" r="3" fill="#2B3D8F" />
        <path d="M30 12v18l10 6" stroke="#2B3D8F" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8 8l12 8" stroke="#E8A838" strokeWidth="3" strokeLinecap="round" />
        <path d="M10 18l8 4" stroke="#E8A838" strokeWidth="2.5" strokeLinecap="round" />
        <circle cx="50" cy="48" r="10" fill="#4CAF50" />
        <path d="M45 48l3 3 7-6" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    title: "Expédition sous 48 heures",
    subtitle: "ouvrées pour les produits en stock",
  },
  {
    icon: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" width="56" height="56">
        <rect x="16" y="10" width="32" height="44" rx="3" fill="#2B3D8F" />
        <rect x="20" y="6" width="24" height="6" rx="2" fill="#1a2d70" />
        <rect x="22" y="20" width="20" height="28" rx="2" fill="#E8F4FD" />
        <circle cx="32" cy="52" r="3" fill="#1a2d70" />
        <path d="M28 34l4 4 8-8" stroke="#4CAF50" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="48" cy="46" r="12" fill="#F9A825" />
        <path d="M44 42h8M48 38v8" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
        <rect x="40" y="50" width="16" height="4" rx="1" fill="#E8961E" />
      </svg>
    ),
    title: "Livraison",
    subtitle: "porte-à-porte à domicile.",
  },
  {
    icon: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" width="56" height="56">
        <path d="M8 40c6-4 12-2 18 2s12 6 18 2l10-8" stroke="#5C4033" strokeWidth="3" strokeLinecap="round" fill="none" />
        <path d="M8 44c5-2 12-1 18 3s12 5 18 1l10-8" fill="#D4A574" stroke="none" />
        <ellipse cx="32" cy="36" rx="20" ry="8" fill="#C8956C" />
        <rect x="18" y="20" width="24" height="16" rx="3" fill="#E8A838" />
        <path d="M22 24h16M22 28h12" stroke="#2B3D8F" strokeWidth="2" strokeLinecap="round" />
        <path d="M44 16l8 4-4 6-8-4z" fill="#4CAF50" />
        <path d="M48 10l6 2-2 4-6-2z" fill="#66BB6A" />
        <rect x="10" y="28" width="8" height="12" rx="2" fill="#E53935" />
        <path d="M12 32h4M12 35h4" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
    title: "Paiement",
    subtitle: "à la livraison.",
  },
  {
    icon: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" width="56" height="56">
        <circle cx="32" cy="20" r="12" fill="#D4A574" />
        <path d="M20 20c0-6.627 5.373-12 12-12s12 5.373 12 12" fill="#2B3D8F" />
        <ellipse cx="32" cy="20" rx="6" ry="4" fill="#C8956C" />
        <path d="M16 52c0-8.837 7.163-16 16-16s16 7.163 16 16" fill="#2B3D8F" />
        <rect x="4" y="8" width="18" height="14" rx="3" fill="#1a2d70" />
        <rect x="6" y="10" width="14" height="10" rx="2" fill="#3d5af1" />
        <path d="M8 13h10M8 16h7" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M4 22l4-2" stroke="#2B3D8F" strokeWidth="2" strokeLinecap="round" />
        <circle cx="8" cy="6" r="4" fill="#E8A838" />
        <path d="M6 6l1.5 1.5L10 4" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    title: "Notre équipe dédiée",
    subtitle: "à votre écoute.",
  },
];
  return (
    <div className="footer">
       <div className="top-footer">
          {features.map((feature, index) => (
            <>
              <div className="feature-item" key={feature.title}>
                <div className="feature-icon">{feature.icon}</div>
                <div className="feature-text">
                  <div className="title">{feature.title}</div>
                  <div className="subtitle">{feature.subtitle}</div>
                </div>
              </div>
              {index < features.length - 1 && (
                <div className="top-footer-divider" key={`div-${index}`} />
              )}
            </>
          ))}
        </div>
      <div className="footerBottom">
      <div className="foot">
        <h3>Ebuy</h3>
        <h3><a href="/qui-sommes-nous"> Qui sommes-nous ?</a></h3>
        <h3><a href="/nos-marques">Nos marques</a></h3>
        <h3><a href="/politique-de-confidentialite">Politiques de Confidentialités</a></h3>
      </div>
      <div className="footMiddle">
        <div>
        <img src={logo} alt="" className="logoFoot" />
        </div>
        <div className="socialFoot">
         <a href="https://www.facebook.com/profile.php?id=61556332296913" target="_blank" rel="noreferrer">
          <FacebookIcon fontSize="medium"/></a> 
         <a href="https://www.instagram.com/ebuy.tunisie" target="_blank" rel="noreferrer">
          <InstagramIcon fontSize="medium"/></a>
         <a href="https://www.youtube.com/@EbuyTunisia" target="_blank" rel="noreferrer">
           <YouTubeIcon fontSize="medium"/></a>
        </div>
        <p className="copy">
              © 2024 <span>Ebuy Tunisie</span> — Tous droits réservés.
            </p>
      </div>
      <div className="foot">
        
        <h3>BESOIN D'AIDE?<br/>Nous sommes là pour vous </h3>
        
        <span>Hotline clients <SupportAgentIcon sx={{color:'white',marginLeft:'1px'}}/></span>
        <span>Lundi - Vendredi : 10h - 17h</span>
        <a href="tel:27890006"><Button  sx={{color:'white',fontFamily:'Exo'}} startIcon={<LocalPhoneIcon/>}>27 890 006</Button> </a>
        <a href="whatsapp://send?phone=+216 27890006"><Button sx={{color:'white',fontFamily:'Exo'}} startIcon={<WhatsAppIcon/>}>27 890 006</Button> </a>
        <a href="mailto:hello.ebuytn@gmail.com"><Button sx={{color:'white',fontFamily:'Exo'}} startIcon={<MailIcon/>}>hello.ebuytn@gmail.com</Button> </a>
      </div>
      
      </div>
    </div>
  );
}
